import { InteractLinkIcon, InteractShareIcon, MediaXIcon } from '@/client/assets';
import { Button, ButtonProps } from '@/client/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/client/components/ui/dropdown-menu';
import useLocale from '@/client/hooks/use-locale';
import { cn } from '@/client/utils';
import { pickLocaleText } from '@/client/utils/i18n-content';
import { getTwitterShareUrl } from '@/libs/common/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

type ShareMarketProps = ButtonProps & {
  marketName: string;
  nameI18n?: Record<string, string>;
  marketAddress: string;
  iconClassName?: string;
};
export const ShareMarket = ({
  marketName,
  nameI18n,
  className,
  marketAddress,
  iconClassName,
  ...props
}: ShareMarketProps) => {
  const { t } = useTranslation(['market']);
  const { locale } = useLocale();
  const localizedName = pickLocaleText(nameI18n, locale) ?? marketName;
  const href = `${window.location.origin}/market/${marketAddress}`;
  const shareUrl = useMemo(
    () =>
      getTwitterShareUrl(`${localizedName}
${t('im-trading-on-promethex-make-your-prediction')}
👇
${href}?t=${Math.ceil(Date.now() / 1e3)}
#PrometheX #Prediction #PredictionMarket`),
    [href, localizedName, t]
  );
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success(t('copied-to-clipboard'));
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" {...props} className={cn('size-9 rounded-full !ring-none', className)}>
          <InteractShareIcon className={cn('size-4 fill-current', iconClassName)} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="p-2 rounded-4 bg-card">
        <DropdownMenuItem className="cursor-pointer text-sm font-medium p-2 pe-3 active:bg-foreground/10">
          <a href={shareUrl} target="_blank" className="inline-flex gap-1 items-center">
            <MediaXIcon className="size-4 fill-current" />
            {t('share-to-x-twitter')}
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleCopy(href)}
          className="cursor-pointer text-sm font-medium p-2 pe-3 active:bg-foreground/10"
        >
          <InteractLinkIcon className="size-4 fill-current" />
          {t('copy-link')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
